<template>
    <section class="buildings-map-list">
        <div class="buildings-map-list__list" v-if="buildings.length > 0">
            <div class="buildings-map-list__item buildings-map-list__item--fixed"  v-for="(building, index) in fixed">
                <figure class="buildings-map-list__item-img">
                    <img :src="building.preview" v-if="building.preview" height="120px">
                    <img src="/assets/common/images/no-image-icon.jpg" v-else height="140px">
                </figure>
                <div class="buildings-map-list__item-content">
                    <h4 class="buildings-map-list__item-title buildings-map-list__item-title--fixed">
                        <a :href="'/kottedzhnyj-poselok/' + building.slug" class="map-balloon__link" target="_blank">
                            {{building.name}} <i class="fas fa-star"></i>
                        </a>
                    </h4>
                    <div class="buildings-map-list__item-option" v-if="building.price_m2_from || building.price_m2_to">
                      <svg viewBox="0 0 25 25" class="list-item-options__icon" >
                        <use xlink:href="/assets/site/images/sprites.svg?ver=31#sprite-sprite-m2"></use>
                      </svg>
                <span v-if="building.price_m2_from">
                    от {{building.price_m2_from}} &#8381;
                </span>
                        <span v-if="building.price_m2_to">
                    до {{building.price_m2_to}}
                </span>
                        &#8381;/м2
                    </div>
                    <div class="buildings-map-list__item-option" v-if="building.apartment_price_from || building.apartment_price_to">
                      <svg viewBox="0 0 25 25" class="list-item-options__icon" >
                        <use xlink:href="/assets/site/images/sprites.svg?ver=31#sprite-house"></use>
                      </svg>
                <span v-if="building.apartment_price_from">
                    от {{building.apartment_price_from}}
                </span>
                        <span v-if="building.apartment_price_to">
                    до {{building.apartment_price_to}}
                </span>
                        &#8381;
                    </div>

                    <div class="list-item__district" style="margin-top: 0.35rem; margin-bottom: 0" v-if="building.district">
                        {{building.district.name}}
                    </div>
                </div>
            </div>
            <div class="buildings-map-list__item"  v-for="(building, index) in buildings">
                <figure class="buildings-map-list__item-img">
                    <img :src="building.preview" v-if="building.preview" height="120px">
                    <img src="/assets/common/images/no-image-icon.jpg" v-else height="140px">
                </figure>
                <div class="buildings-map-list__item-content">
                    <h4 class="buildings-map-list__item-title">
                        <a :href="'/kottedzhnyj-poselok/' + building.slug" class="map-balloon__link" target="_blank">
                            {{building.name}}
                        </a>
                    </h4>
                    <div class="buildings-map-list__item-option" v-if="building.price_m2_from || building.price_m2_to">
                <span v-if="building.price_m2_from">
                    от {{building.price_m2_from}}
                </span>
                        <span v-if="building.price_m2_to">
                    до {{building.price_m2_to}}
                </span>
                        &#8381;/м2
                    </div>
                    <div class="buildings-map-list__item-option" v-if="building.apartment_price_from || building.apartment_price_to">
                <span v-if="building.apartment_price_from">
                    от {{building.apartment_price_from}}
                </span>
                        <span v-if="building.apartment_price_to">
                    до {{building.apartment_price_to}}
                </span>
                        &#8381;
                    </div>

                    <div class="list-item__district" style="margin-top: 0.35rem; margin-bottom: 0" v-if="building.district">
                        {{building.district.name}}
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center" style="padding: 1rem 1.1rem" v-else>
            Выберите параметры в фильтре
        </div>

    </section>
</template>
<script>
    export default {
    props:{
        buildings:Array,
    },
        data() {
        return {
            fixed:[],
        }
        },
        methods:{
        getFixed() {
            axios.get('/api/buildings-map/fixed')
                .then((response) => {
                    this.fixed = response.data;
                })
                .catch((error) => {

                })
        }
        },
        mounted() {
        this.getFixed();
        }
    }
</script>
